// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3_rzw","title":"Info_title__23nsU","selects":"Info_selects__2Ofrv","requiredAsterisk":"Info_requiredAsterisk__oPzJC"};